import React from "react"
import { withRouter } from "react-router-dom"
import { Container } from "react-bootstrap"

const Rules = () => {
    return (
        <Container
            className="d-flex flex-column justify-content-center align-self-center align-items-center w-100 textSmall textFont box p-md-5 mb-5"
            style={{maxWidth: "60rem"}}>
            <h3>Zasady składania zapytań:</h3>
            <br/>
            <p className="w-100">
                1. Aby skonfigurować mapnik skorzystaj z zakładki KONFIGURATOR.
                <br/>
                2. Uzupełnij wszystkie wymagane pola.
                <br/>
                3. Zaznacz interesujące Cię opcje dodatkowe.
                <br/>
                4. Wprowadź swoje dane oraz zaznacz rodzaj dostawy.
                <br/>
                5. Wyślij zapytanie.
                <br/>
                <br/>
                W przeciągu 48h otrzymasz potwierdzenie ceny i czasu realizacji. Po akceptacji należy opłacić
                zamówienie. Zwrotnie otrzymasz również podgląd skonfigurowanego mapnika. Czas realizacji
                liczony jest od momentu zaksięgowania wpłaty na koncie.
                <br/>
            </p>
            <br/>
            <h3>Zasady ogólne:</h3>
            <br/>
            <p className="w-100">
                1. Czas realizacji jest uzależniony od wybranych opcji dodatkowych i wynosi do 21 dni roboczych.
                <br/>
                2. Odbiór osobisty możliwy jest we Wrocławiu po wcześniejszym umówieniu.
                <br/>
                3. Wysyłka realizowana jest kurierem lub do Paczkomatu.
                <br/>
                4. Mapniki są wykonywane na indywidualne zamówienie i w związku z tym nie podlegają
                zwrotowi.
                <br/>
                5. Na mapnik udzielana jest 12 miesięczna gwarancja.
                <br/>
                6. Gwarancji nie podlegają części zużywające się takie jak folia blatu i płyta blatu.
                <br/>
                <br/>
                Jeśli potrzebujesz nietypowego wykonania wyślij zapytanie na maila i opisz co dokładnie jest potrzebne.
            </p>
        </Container>
    )
}

export default withRouter(Rules)